import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	tryCloud: {
		id: 'TryPageTemplate.tryCloud',
		defaultMessage: 'Try cloud',
	},
	downloadNow: {
		id: 'TryPageTemplate.downloadNow',
		defaultMessage: 'Download now',
	},
});
